var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.696 15.212H.586V5.221h3.11v9.991Zm-1.64-11.24h-.022A1.733 1.733 0 0 1 .172 2.24c0-.987.751-1.734 1.907-1.734a1.742 1.742 0 0 1 1.88 1.734c0 .969-.734 1.733-1.903 1.733Zm14.116 11.24h-3.556v-5.169c0-1.333-.55-2.275-1.777-2.275a1.778 1.778 0 0 0-1.69 1.222c-.074.264-.1.54-.075.813v5.41H5.6s.044-9.156 0-9.988H9.1v1.583c.209-.685 1.333-1.663 3.11-1.663 2.223 0 3.96 1.436 3.96 4.53v5.537Z",
    fill: "#0F1125"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.172 .5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgLinkedin;